import Axios from 'axios'
import { getErrorMessage, RESOLVER_URL } from '@/main'

const state = {
  _lists: [],
  _hcodes: [],
}

const getters = {
  comptoxLists: (state) => {
    return state._lists
  },
  hcodes: (state) => {
    return state._hcodes
  },
}

const mutations = {
  setComptoxLists: (state, payload) => {
    state._lists = payload
  },
  setHcodes: (state, payload) => {
    state._hcodes = payload
  },
}

const actions = {}

export function prepareResolverMetadata(context) {
  Axios.get(`${RESOLVER_URL}/metadata`)
    .then((response) => {
      context.commit('setFeatures', { resolver: { category: 'module' } })
      context.commit('setComptoxLists', response.data.lists)
      context.commit('setHcodes', response.data.hcodes)
    })
    .catch((error) => {
      console.warn('RESOLVER module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { resolver: {} })
    })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
